var _path, _rect, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _circle3, _circle4, _path8, _path9, _path10, _rect2, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#58565d",
    d: "M27,28a.49971.49971,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.49971.49971,0,0,1,27,28Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 28,
    x: 1.5,
    y: 3.5,
    fill: "#b28966",
    rx: 2,
    ry: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b6847",
    d: "M2.5,29.5V5.5a2,2,0,0,1,2-2h-1a2,2,0,0,0-2,2v24a2,2,0,0,0,2,2h1A2,2,0,0,1,2.5,29.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.50016,29.5H4.5a1,1,0,0,1-1-1V6.5a1,1,0,0,1,1-1h15a1,1,0,0,1,1,1V25.49983"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e2",
    d: "M4.5,28.5V6.5a1,1,0,0,1,1-1h-1a1,1,0,0,0-1,1v22a1,1,0,0,0,1,1h1A1,1,0,0,1,4.5,28.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#afaeb3",
    d: "M14.5,3.5V3.14251A2.598,2.598,0,0,0,12.25781.51294,2.50052,2.50052,0,0,0,9.5,3v.5h-1a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1v-2a1,1,0,0,0-1-1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b8891",
    d: "M10.5 3A2.491 2.491 0 0 1 12.50226.56329a2.26127 2.26127 0 0 0-.24445-.05035A2.50053 2.50053 0 0 0 9.5 3v.5h1zM8.5 6.5v-2a1 1 0 0 1 1-1h-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1A1 1 0 0 1 8.5 6.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3.5,
    r: 0.5,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#afaeb3",
    d: "M16.5,29.5v-3a1,1,0,0,1,1-1h3Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1.5,
    fill: "#58565d"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 24,
    r: 1.5,
    fill: "#58565d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 18,
    r: 1.5,
    fill: "#58565d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#58565d",
    d: "M17.5 12h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zM14.5 14h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zM17.5 18h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zM14.5 20h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zM17.5 24h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zM14.5 26h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zM31 10.5v4a.5.5 0 0 1-1 0v-4a.49511.49511 0 0 0-.5-.5h-1a.5.5 0 0 1 0-1h1A1.498 1.498 0 0 1 31 10.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f6db4",
    d: "M28.5,6.5V24.83a1.96852,1.96852,0,0,1-.4,1.2l-.6.8-.5.67-.5-.67-.6-.8a1.96852,1.96852,0,0,1-.4-1.2V6.5a1.003,1.003,0,0,1,1-1h1A1.003,1.003,0,0,1,28.5,6.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f53a4",
    d: "M26.5,24.83V6.5a1.003,1.003,0,0,1,1-1h-1a1.003,1.003,0,0,0-1,1V24.83a1.96852,1.96852,0,0,0,.4,1.2l.6.8.5.67.5-.67-.6-.8A1.96852,1.96852,0,0,1,26.5,24.83Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 28.5,
    y: 9,
    fill: "#3c3b41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#58565d",
    d: "M28.5,23.5v1.33a1.96852,1.96852,0,0,1-.4,1.2L27,27.5l-1.1-1.47a1.96852,1.96852,0,0,1-.4-1.2V23.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b41",
    d: "M26.5,26.83l-.6-.8a1.96861,1.96861,0,0,1-.4-1.2V23.5h1c0,.31715-.00658.63555-.00414.95192.00243.31308.0306.62462.03835.93773q.012.48488-.01541.96966C26.50992,26.5162,26.50507,26.6729,26.5,26.83Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#58565d",
    d: "M28.5,6.5V9h-3V6.5a1.003,1.003,0,0,1,1-1h1A1.003,1.003,0,0,1,28.5,6.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b41",
    d: "M27.5,5.5h-1a1.003,1.003,0,0,0-1,1V9h1V6.5A1.003,1.003,0,0,1,27.5,5.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTasks);
export default __webpack_public_path__ + "static/media/ic_tasks.539faa042f61e1e9ccca60dfede52b4d.svg";
export { ForwardRef as ReactComponent };